var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cityLocation"},[_c('div',{staticClass:"areaMap"},[_c('leaflet-block-layer',{attrs:{"cname":_vm.cname,"polygondata":_vm.polygondata}})],1),_c('div',{staticClass:"swipercontainer"},[_c('down',{attrs:{"imglist":_vm.imglist}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }